/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here... //
function replaceUrlParam(url, paramName, paramValue){
    if (paramValue == null) {
        paramValue = '';
    }
    var pattern = new RegExp('\\b('+paramName+'=).*?(&|#|$)');
    if (url.search(pattern)>=0) {
        return url.replace(pattern,'$1' + paramValue + '$2');
    }
    url = url.replace(/[?#]$/,'');
    return url + (url.indexOf('?')>0 ? '&' : '?') + paramName + '=' + paramValue;
}


$(".changeView").click(function(e){
  e.preventDefault();
  var param = $(this).attr("href");
  var currentUrl = window.location.href;
  var newUrl = replaceUrlParam(currentUrl, "view", param);
  if (param == ""){
    newUrl = replaceUrlParam(newUrl, "page", "1");
  }
  window.location.href = newUrl;
})